<template>
    <div class="vrm-tpl-unsubscribe-alarm-notifications">
        <div class="vrm-header--site vrm-contains-logo">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 vrm-header__inner">
                        <img class="vrm-logo" :src="logoUrl" />
                    </div>
                </div>
            </div>
        </div>
        <main class="container">
            <div class="row">
                <div
                    class="col-xxs-12 col-xxs-offset-0 col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 col-lg-6 col-lg-offset-3"
                >
                    <form
                        class="vrm-panel centered"
                        @submit.prevent="onSubmit()"
                        @reset.prevent="onReset()"
                    >
                        <i class="vrm-panel__top-icon sg-vrm-icon_102_notification-disabled-16px" />
                        <h1>
                            {{
                                $t('unsubscribe.title', {
                                    i18nFallback: 'Are you sure about unsubscribing?',
                                })
                            }}
                        </h1>
                        <p>
                            {{ $t('unsubscribe.explainer') }}
                        </p>
                        <div v-if="success">
                            <p>
                                {{ $t('unsubscribe.success') }}
                            </p>
                        </div>
                        <div v-else class="sg-btn__container">
                            <div class="row">
                                <div class="col-xs-12 col-sm-6">
                                    <button
                                        type="submit"
                                        :disabled="busy"
                                        class="sg-btn sg-blue sg-element"
                                    >
                                        {{
                                            $t('unsubscribe.confirm', {
                                                i18nFallback: 'Yes, unsubscribe me',
                                            })
                                        }}
                                    </button>
                                </div>
                                <div class="col-xs-12 col-sm-6">
                                    <button
                                        type="reset"
                                        :disabled="busy"
                                        class="sg-btn sg-site sg-element"
                                    >
                                        {{
                                            $t('unsubscribe.cancel', {
                                                i18nFallback:
                                                    'No, I want to keep receiving notifications',
                                            })
                                        }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </main>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Component, Vue } from 'vue-property-decorator';
import { AngularRoute, ngInject } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import VrmDropdown from '@/vue/components/shared/VrmDropdown';

@Component({
    components: { VrmDropdown },
})
@AngularRoute('unsubscribe-alarm-notifications', '/unsubscribe-alarm-notifications?uuid', {
    slot: 'base',
    data: {
        skipLoginCheck: true,
    },
})
@AngularLocaleBundle('unsubscribe')
export default class UnsubscribeFromAlarmNotifications extends Vue {
    @ngInject()
    ApiService;

    busy = false;
    success = false;

    get uuid() {
        return this.$route.params.uuid;
    }

    async onSubmit() {
        this.busyWork(async () => {
            await this.ApiService.call2(
                `/unsubscribe-alarm-notifications?uuid=${this.uuid}`,
                null,
                {
                    skipAuthorization: true,
                },
            );
            this.success = true;
        });
    }

    onReset() {
        this.$router.push({
            name: 'login',
        });
    }

    async busyWork(callback) {
        if (this.busy) return;
        try {
            this.busy = true;
            return await callback();
        } finally {
            this.busy = false;
        }
    }

    @ngInject()
    $rootScope;

    get logoUrl() {
        return this.$rootScope.logoRGB;
    }
}
</script>
